import "@fontsource/open-sans";
import { LightTheme } from ".";
// Properties defined here will be overridden by properties defined in
// either the light_theme or dark_theme. Theme construction occurs in the
// themeFactory module. The default theme is "light".
// Properties defined here should be common rules and styles that can be shared
// across the "light" and "dark" theme. Theme specific rules and styles should
// be defined in the respective theme definition.
/**
 * Default theme values for Chart instances.
 */ export var attuned_theme = {
    _name: 'ATTUNED',
    textStyle: {
        fontFamily: 'Open Sans, Helvetica, Roboto, Arial, sans-serif',
        lineHeight: 16
    },
    title: {
        textStyle: {
            color: '#008acd'
        },
        subtextStyle: {
            color: '#aaaaaa'
        }
    },
    bar: {
        itemStyle: {
            color: LightTheme._palette.graphics.motivatorLevels.needToHave
        },
        tooltip: {
            position: 'bottom',
            borderWidth: 0,
            borderRadius: 5,
            backgroundColor: '#33373E',
            textStyle: {
                fontSize: 12,
                color: '#FFFFFF'
            }
        }
    },
    pie: {
        labelLine: {
            show: false
        },
        itemStyle: {
            color: LightTheme._palette.graphics.motivatorLevels.needToHave
        },
        tooltip: {
            position: 'bottom',
            borderWidth: 0,
            borderRadius: 5,
            backgroundColor: '#33373E',
            textStyle: {
                fontSize: 12,
                color: '#FFFFFF'
            }
        }
    },
    scatter: {
        tooltip: {
            position: 'bottom',
            borderWidth: 0,
            borderRadius: 5,
            backgroundColor: '#33373E',
            textStyle: {
                fontSize: 12,
                color: '#FFFFFF'
            }
        },
        markArea: {
            label: {
                fontSize: 13,
                fontWeight: 600
            }
        },
        markLine: {
            label: {
                fontSize: 13,
                fontWeight: 600
            }
        }
    },
    categoryAxis: {
        axisLine: {
            show: false
        },
        axisLabel: {
            fontSize: 14,
            fontWeight: 600,
            show: true
        },
        axisTick: {
            show: false
        },
        splitLine: {
            show: false
        },
        splitArea: {
            show: false
        }
    },
    valueAxis: {
        axisLine: {
            show: false
        },
        axisLabel: {
            show: false
        },
        axisTick: {
            show: false
        },
        splitLine: {
            show: false
        },
        splitArea: {
            show: false
        }
    }
};

//# sourceMappingURL=attuned_theme.js.map